import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import { FeedbackModalComponent } from './modals/feedback-modal/feedback-modal.component';

@NgModule({
	imports: [CommonModule, SharedModule],
	declarations: [FeedbackModalComponent],
	exports: [FeedbackModalComponent],
})
export class FeedbackModule {}
